import { connectHook } from 'app/common/components/connect-hook';
import { ProjectMenu } from './project-menu.js';
import { useProjectMenu } from './project-menu-hook.js';

export default connectHook(ProjectMenu, useProjectMenu);
